export const Colors = {
  PRIMARY: '#3498db',
  SECONDARY: '#e74c3c',
  TEXT: '#9396a5',
};

export const Fonts = {
  FAMILY: 'Arial, sans-serif',
};

export const Regex = {
  TAG: /^(?!.*##.*)(?!.*#w#.*)(?!.*##w##.*)(?!.*#(w+)#.*)#.*$/g,
};
